import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { svgMap } from 'core/utils/slugMaps';

import {
	StyledSvgBlock,
	StyledDescription,
	SvgContainer,
} from './subNavStyles';

class SvgBlock extends PureComponent {
	render() {
		const { imageTitle, href, slug, iconWidth, iconHeight } = this.props;
		const SvgComponent = slug in svgMap ? svgMap[slug] : svgMap[slug.split("/").shift()];

		return (
			<StyledSvgBlock href={href}>
				{SvgComponent && (
					<SvgContainer><SvgComponent width={iconWidth} height={iconHeight} /></SvgContainer>
				)}
				<StyledDescription fontSize={16} marginTop={16}>{imageTitle}</StyledDescription>
			</StyledSvgBlock>
		);
	}

	static propTypes = {
		imageTitle: PropTypes.string.isRequired,
		href: PropTypes.string.isRequired,
		slug: PropTypes.string.isRequired,
		iconWidth: PropTypes.number,
		iconHeight: PropTypes.number,
	}

	static defaultProps = {
		iconWidth: 80,
		iconHeight: 90,
	}
}

export default SvgBlock;
